var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.description)?_c('v-layout',{staticClass:"flex site-content-wrap site_bg"},[_c('v-container',[_c('h4',{staticClass:"pb-4",domProps:{"textContent":_vm._s(_vm.title)}}),_c('p',{staticStyle:{"column-count":"4","column-rule":"1px solid #ddd"},domProps:{"innerHTML":_vm._s(_vm.description)}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }